import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { App } from '@df/core/app';
import { UiComponent } from '@df/ui/ui.component';
import { PaypalPayInThreeService } from './paypal-pay-in-three.service';

@Component({
    selector: 'paypal-pay-in-three-message',
    templateUrl: './paypal-pay-in-three-message.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class PaypalPayInThreeMessageComponent extends UiComponent implements OnInit {
    @Input({ required: true })
    amount!: string;
    private paypalPayInThreeService = inject(PaypalPayInThreeService);

    @Input()
    mode?: 'default' | 'basket' = 'default';

    private app = inject(App);
    private loadedComponentsId?: string;

    private load() {
        if (!this.app.isPlatformBrowser) {
            return;
        }
        if (this.mode !== 'basket') {
            this.paypalPayInThreeService.load();
        }
    }

    override detectChanges(): void {
        this.load();
        super.detectChanges();
    }
}
